import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Clock } from "lucide-react";
import { placeUrl } from "../lib/placeUrl";

// Top-of-page note for places Google reports as closed.
export const ClosedNotice = ({ status, alternatives = [], moreUrl, moreLabel }) => {
  if (status === "CLOSED_TEMPORARILY") {
    return (
      <div data-testid="temporarily-closed-notice" className="mb-4 flex items-start gap-2 rounded-2xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-900">
        <Clock className="w-4 h-4 mt-0.5 shrink-0" />
        <span><strong>Temporarily closed.</strong> Check with the business before you visit.</span>
      </div>
    );
  }
  if (status !== "CLOSED_PERMANENTLY") return null;
  return (
    <div data-testid="permanently-closed-notice" className="mb-5 rounded-2xl border border-red-300 bg-red-50 px-5 py-4 text-sm text-red-900">
      <div className="flex items-center gap-2 font-bold text-base">
        <AlertTriangle className="w-5 h-5" /> Permanently closed
      </div>
      <p className="mt-1">
        This place has closed for good.{alternatives.length > 0 ? " Here are similar dog-friendly places nearby:" : ""}
      </p>
      {alternatives.length > 0 && (
        <ul className="mt-2 space-y-1" data-testid="closed-alternatives">
          {alternatives.slice(0, 5).map((p) => (
            <li key={p.id}>
              <Link to={placeUrl(p)} className="font-semibold underline underline-offset-2 hover:text-red-700" data-testid={`closed-alt-${p.id}`}>
                {p.name}
              </Link>
              {p.city ? <span className="text-red-900/70"> · {p.city}{p.state ? `, ${p.state}` : ""}</span> : null}
            </li>
          ))}
        </ul>
      )}
      {moreUrl && (
        <Link to={moreUrl} className="mt-2 inline-block font-semibold underline underline-offset-2" data-testid="closed-more-link">
          {moreLabel}
        </Link>
      )}
    </div>
  );
};
